/**
 * Client for /api/org/:orgId/audience/*.
 *
 * All org-scoped reads/writes go through the server's Integration-SDK
 * proxy, gated by VIEW_RENTED_AUDIENCE (reads + audience mgmt) or
 * SEND_NEWSLETTERS (email campaign create/edit/send). Members can't
 * reach any of these — see server/routes/org.js for the matrix.
 *
 * Note: prior to 2026-05-17 the base was /api/organizations/:orgId/audience.
 * Routes consolidated under /api/org.
 */

import { get, postJson } from '../httpClient';

const base = orgId => `/api/org/${orgId}/audience`;

export const orgAudienceAPI = {
  // Subscribers
  query: (orgId, params) => get(`${base(orgId)}/subscribers`, params),
  add: (orgId, body) => postJson(`${base(orgId)}/subscribers/add`, body),
  remove: (orgId, body) => postJson(`${base(orgId)}/subscribers/remove`, body),
  getImports: orgId => get(`${base(orgId)}/subscribers/imports`),
  import: (orgId, body) => postJson(`${base(orgId)}/subscribers/import`, body),

  // Lists
  getLists: orgId => get(`${base(orgId)}/lists`),
  createList: (orgId, body) => postJson(`${base(orgId)}/lists/create`, body),
  deleteList: (orgId, body) => postJson(`${base(orgId)}/lists/delete`, body),
  updateList: (orgId, body) => postJson(`${base(orgId)}/lists/update`, body),
  getList: (orgId, listId) => get(`${base(orgId)}/lists/show`, { listId }),
  addMember: (orgId, body) => postJson(`${base(orgId)}/lists/add-member`, body),
  importMembers: (orgId, body) => postJson(`${base(orgId)}/lists/import-members`, body),

  // Emails
  getEmails: orgId => get(`${base(orgId)}/emails`),
  createEmail: (orgId, body) => postJson(`${base(orgId)}/emails`, body),
  updateEmail: (orgId, emailId, body) => postJson(`${base(orgId)}/emails/${emailId}`, body),
  deleteEmail: (orgId, emailId) => postJson(`${base(orgId)}/emails/${emailId}/delete`, {}),
  sendEmail: (orgId, emailId) => postJson(`${base(orgId)}/emails/${emailId}/send`, {}),
};
